<div class="row">
    <div class="col-3">
        <app-control label='Agreement Date' type="datetime" [isDisabled]="true" [(ngModel)]="agreementDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Confirmed By" type="string" [isDisabled]="true" [ngModel]="confirmedByFullName"/>                                
    </div>

    <div class="col-3">
        <app-control label='Cancelation Date' type="datetime" [isDisabled]="true" [(ngModel)]="cancelationDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Canceled By" type="string" [isDisabled]="true" [ngModel]="canceledByFullName"/>                                
    </div>    
</div>